import { render, staticRenderFns } from "./pcShare.vue?vue&type=template&id=799f94d4"
import script from "./pcShare.vue?vue&type=script&lang=ts"
export * from "./pcShare.vue?vue&type=script&lang=ts"
import style0 from "./pcShare.vue?vue&type=style&index=0&id=799f94d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports